import { render, staticRenderFns } from "./AdministratorPage.vue?vue&type=template&id=579a984c"
import script from "./AdministratorPage.vue?vue&type=script&lang=js"
export * from "./AdministratorPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports